/// <reference path="../../typings/tsd.d.ts" /> 

module warsApp.services {

    export class ContentPageService extends HttpHandlerService {

        constructor($http: ng.IHttpService) {
            super($http);
        }

        public getContentPagesForConfiguration(): ng.IPromise<Wars.Domain.Model.Dtos.ContentPageDto[]> {
            var params: any = {};
            this.handlerUrl = "api/ContentManagement/ContentPage/GetContentPagesForConfiguration";
            return this.useGetHandler(params).then(
                (result: Wars.Domain.Model.Dtos.ContentPageDto[]) => {
                    return result;
                });
        }

        public getContentPagesForExecution(): ng.IPromise<Wars.Domain.Model.Dtos.ContentPageDto[]> {
            var params: any = {};
            this.handlerUrl = "api/ContentManagement/ContentPage/GetContentPagesForExection";
            return this.useGetHandler(params).then(
                (result: Wars.Domain.Model.Dtos.ContentPageDto[]) => {
                    return result;
                });
        }

        public getContentPageForExecution(id: string): ng.IPromise<Wars.Domain.Model.Dtos.ContentPageDto> {
            var params: any = {};
            this.handlerUrl = "api/ContentManagement/ContentPage/GetContentPageForExecution?id=" + id;
            return this.useGetHandler(params).then(
                (result: Wars.Domain.Model.Dtos.ContentPageDto) => {
                    return result;
                });
        }

        public addContentPage(contentPage: models.ContentPageDto): ng.IPromise<Wars.Domain.Model.Dtos.ContentPageDto> {
            var params = contentPage;
            this.handlerUrl = "api/ContentManagement/ContentPage/CreateContentPage";
            return this.usePostHandler(params);
        }

        public updateContentPage(contentPage: Wars.Domain.Model.Dtos.ContentPageDto): ng.IPromise<Wars.Domain.Model.Dtos.ContentPageDto> {
            var params = contentPage;
            this.handlerUrl = "api/ContentManagement/ContentPage/UpdateContentPage";
            return this.usePostHandler(params);
        }

        public deleteContentPage(contentPage: Wars.Domain.Model.Dtos.ContentPageDto): ng.IPromise<Wars.Domain.Model.Dtos.ContentPageDto> {
            var params = contentPage;
            this.handlerUrl = "api/ContentManagement/ContentPage/DeleteContentPage";
            return this.usePostHandler(params);
        }
    }

    //    public getContentPagesTitles(): ng.IPromise<Wars.Domain.Model.ContentPage[]> {
    //        var namesQuery= this.breezeModule.EntityQuery
    //            .from("ContentPages")
    //            .select("title, id")
    //            .orderBy("title");

    //        return<any>this.executeQuery(namesQuery);
    //    }
}

warsApp.registerService('ContentPageService', ['$http'])